export const ReferenceDataIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2133 8.49996C13.9467 8.49996 14.6667 7.83329 14.0267 5.64662C13.5933 4.17329 12.3267 2.90662 10.8533 2.47329C8.66667 1.83329 8 2.55329 8 4.28662V6.20662C8 7.83329 8.66667 8.49996 10 8.49996H12.2133Z"
        stroke="#010D1D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.333 10.3C12.713 13.3867 9.75296 15.6267 6.38629 15.08C3.85963 14.6733 1.82629 12.64 1.41296 10.1133C0.872961 6.76001 3.09963 3.80001 6.17296 3.17334"
        stroke="#010D1D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
